import type { ReactNode } from 'react';
import { Alert, Button, Skeleton, Text } from '@gravity-ui/uikit';

/**
 * Состояния данных: загрузка — каркасом той же формы, ошибка — с причиной и
 * повтором, пусто — с тем, что сделать дальше.
 */

export function LoadingRows({ rows = 4, height = 40 }: { rows?: number; height?: number }) {
  return (
    <div className="flex flex-col gap-2" aria-busy="true" aria-label="Загрузка">
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} style={{ height, width: '100%', borderRadius: 8 }} />
      ))}
    </div>
  );
}

export function ErrorNote({
  title,
  error,
  onRetry,
}: {
  title: string;
  error: unknown;
  onRetry?: () => void;
}) {
  const message = error instanceof Error ? error.message : 'Сервер не ответил. Проверьте связь и повторите';
  return (
    <Alert
      theme="danger"
      title={title}
      message={message}
      actions={
        onRetry === undefined ? undefined : (
          <Alert.Actions>
            <Alert.Action onClick={onRetry}>Повторить</Alert.Action>
          </Alert.Actions>
        )
      }
    />
  );
}

export function Empty({ title, description, action }: { title: string; description?: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-start gap-2 px-1 py-8">
      <Text variant="subheader-2">{title}</Text>
      {description === undefined ? null : (
        <Text color="secondary" className="max-w-[60ch]">
          {description}
        </Text>
      )}
      {action === undefined ? null : <div className="pt-2">{action}</div>}
    </div>
  );
}

export function RetryButton({ onClick }: { onClick: () => void }) {
  return (
    <Button view="outlined" onClick={onClick}>
      Повторить
    </Button>
  );
}
